import colorPalette from '../color-palette';

const { primary, background, action } = colorPalette;

export default {
  MuiAutocomplete: {
    popupIndicator: {
      marginRight: '12px',
      padding: 0,
      color: primary.main,
    },
    option: {
      borderBottom: '1px solid',
      fontSize: '16px',
      paddingBottom: '1px',
      '&:active': {
        backgroundColor: action.activeOption,
      },
    },
    listbox: {
      padding: 0,
    },
    paper: {
      backgroundColor: background.textInput,
      width: '100%',
      margin: 0,
      marginLeft: '1px',
      borderRadius: 0,
      boxShadow: 'none',
    },
  },
};
